/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IVisualStudioBenefitsDataResult } from "Interfaces/VisualStudioBenefits/IVisualStudioBenefitsDataResult";
import { IVisualStudioBenefitsRequest } from "Interfaces/VisualStudioBenefits/IVisualStudioBenefitsRequest";

import {
  VISUAL_STUDIO_BENEFIT_BASE_URL,
  VISUAL_STUDIO_BENEFIT_DOWNLOAD_URL,
} from "../Constants/SagaConstants";
import { IApiResult2 } from "../Interfaces/IApiResult";
import { post, IHttpResponse } from "./ApiUtils";

/**
 * Search all visual studio benefits for the given tenant.
 */
export async function searchVisualStudioBenefits(
  searchRequest: IVisualStudioBenefitsRequest,
  tenant: string
): Promise<IHttpResponse<IApiResult2<IVisualStudioBenefitsDataResult>>> {
  const url = VISUAL_STUDIO_BENEFIT_BASE_URL.replace("{tenant}", tenant) + "/search";
  return await post<IApiResult2<IVisualStudioBenefitsDataResult>>(url, searchRequest, true);
}

/**
 * Download visual studio benefit requests for a given tenant.
 */
export async function downloadRequestsToCsv(
  tenant: string
): Promise<IHttpResponse<IApiResult2<string>>> {
  const url = VISUAL_STUDIO_BENEFIT_DOWNLOAD_URL.replace("{tenant}", tenant.toLocaleLowerCase());
  return await post<IApiResult2<string>>(url, {}, true, false, {
    method: "POST",
    body: "",
    headers: { "Content-Type": "application/octet-stream" },
  });
}
